import React from 'react';
import { Label, TextField, Text, Icon, DefaultButton } from '@fluentui/react';

interface IConfirmacion {
  entrenadorName: string;
  showEmailLegend: boolean;
  reset: () => void;
}
export const Confirmacion = (props: IConfirmacion) => {
  return (
    <div className="text-center">
      <div>
        <Icon iconName="SkypeCircleCheck" style={{ fontSize: 100, color: '#107C10' }}></Icon>
      </div>
      <div className="mt-2">
        <Text block variant="xLarge">
          ¡Listo {props.entrenadorName}!
        </Text>
        <Text block className="mt-2" variant="large">
          Ya te registramos tu solicitud para ser entrenador.
        </Text>
        {props.showEmailLegend && (
          <Text block className="mt-2" variant="smallPlus">
            Te enviamos un comprobante a tu email
          </Text>
        )}
      </div>
      <div className="mt-2">
        <DefaultButton text="Volver al inicio" onClick={props.reset} />
      </div>
    </div>
  );
};
